(function(){
    'use strict'

    angular.module('app.core')
    .factory('UserInfoService', UserInfoService);

    function UserInfoService(){

        var userInfo = {
            userId: '',
            userName: '',
            email: '',
            userDisplayName: '',
            token: null,
            refreshToken: null,
            tokenExpiresIn: 0,
            isAuthenticated: false,
            clienteId: 0,
            permisos: null,
            companiaId: null,
            companiaNombre: ''
        };

        var searchKeys = [
        ];

        var api = {
            userInfo: userInfo,
            setUser: setUser,
            setRefreshTokenInfo: setRefreshTokenInfo,
            getCliente: getCliente,
            getToken: getToken,
            setToken: setToken,
            getRefreshToken: getRefreshToken,
            getCompaniaId: getCompaniaId,
            setCompania: setCompania,
            logoutUser:logoutUser,
            getPermisos: getPermisos,
            saveDataOnSessionStorage: saveDataOnSessionStorage,
            getDataFromSessionStorage: getDataFromSessionStorage,
            deleteDataFromSessionStorage: deleteDataFromSessionStorage,
            searchKeys: searchKeys,
            removeSearchCriterias: removeSearchCriterias,
            eliminarBloqueosUsuario: true,
            getEmail: getEmail
        };

        getUserInfoFromSessionStorage();

        return api;

        function getCliente(){
            return api.userInfo.clienteId;
        }

        function getToken(){
            return api.userInfo.token;
        }

        function getRefreshToken(){
            return api.userInfo.refreshToken;
        }

        function setCompania(compania){
            api.userInfo.companiaId = compania.codigo;
            api.userInfo.companiaNombre = compania.nombre;
            saveUserInfoOnSessionStorage();
            removeSearchCriterias();
        }

        function getCompaniaId(){
            return api.userInfo.companiaId;
        }

        function getEmail(){
            return api.userInfo.email;
        }

        function getPermisos(permisoId){
            return api.userInfo.permisos.find((permiso) => {
                return permiso.permisoId === permisoId;
            });
        }

        function setToken(token){
            api.userInfo.token = token;
        }

        function setUser(user, tokenInfo, loginInfo){
            api.userInfo.userId = user.id;
            api.userInfo.userName = user.userName;
            api.userInfo.isAuthenticated = user.isAuthenticated;
            api.userInfo.token = tokenInfo.access_token;
            api.userInfo.refreshToken = tokenInfo.refresh_token;
            api.userInfo.tokenExpiresIn = tokenInfo.expires_in;
            api.userInfo.userDisplayName = loginInfo.usuario.nombre;
            api.userInfo.clienteId = loginInfo.usuario.clienteId;
            api.userInfo.permisos = loginInfo.permisos;
            api.userInfo.email = loginInfo.usuario.email;
            saveUserInfoOnSessionStorage();
            removeSearchCriterias();
        }

        function setRefreshTokenInfo(tokenInfo){
            api.userInfo.token = tokenInfo.access_token;
            api.userInfo.refreshToken = tokenInfo.refresh_token;
            api.userInfo.tokenExpiresIn = tokenInfo.expires_in;
            saveUserInfoOnSessionStorage();
        }

        function saveUserInfoOnSessionStorage(){
            sessionStorage.setItem('userInfo', JSON.stringify(api.userInfo));
        }

        function getUserInfoFromSessionStorage(){
            var info = sessionStorage.getItem('userInfo');
            if(info){
                api.userInfo = JSON.parse(info);
            }
        }

        function saveDataOnSessionStorage(key, value){
            sessionStorage.setItem(key, JSON.stringify(value));
        }

        function getDataFromSessionStorage(key){
            var data = sessionStorage.getItem(key);
            return JSON.parse(data);
        }

        function deleteUserInfoOnSessionStorage(){
            sessionStorage.removeItem('userInfo');
        }

        function deleteDataFromSessionStorage(key){
            sessionStorage.removeItem(key);
        }

        function logoutUser(){
            api.userInfo.isAuthenticated = false;
            api.userInfo.token = null;
            api.userInfo.companiaId = null;
            api.userInfo.companiaNombre = '';
            deleteUserInfoOnSessionStorage();
            removeSearchCriterias();
        }

        function removeSearchCriterias(){
            searchKeys.forEach(function(item){
                deleteDataFromSessionStorage(item);
            });
        };

    };


})();